module.exports = __webpack_public_path__ + "static/media/IpadPro-dark.230f26d7.png";